@if (selectedAsset) {
  <div class="p-2 d-flex flex-column align-items-center">
    <!-- Row 1: Selected Asset label and Remove button -->
    <div class="d-flex gap-4 align-items-center w-100 justify-content-between mb-3">
      <label class="fs-5 fw-bold">Selected Asset</label>
      <button class="btn btn-sm btn-danger" (click)="removeSelectedAsset()">Remove</button>
    </div>
    <!-- Grid: Labels and Values in two synchronized rows -->
    <div class="d-flex flex-column overflow-auto w-100">
      <div class="d-flex gap-1 flex-nowrap">
        <div class="column">Asset ID:</div>
        <div class="column">{{selectedAsset.id}}</div>
        @for (datum of compiledAssetData; track datum) {
          <div class="column">
            @switch (datum.type) {
              @case ('trueFalse') {
                <span>{{datum.value == 0 ? 'True' : 'False'}}</span>
              }
              @case ('location') {
                <span>{{datum.value[1]}}, {{datum.value[0]}}</span>
              }
              @case ('chooseMultiple') {
                <span>{{ isArray(datum.value) ? datum.value.join(', ') : datum.value }}</span>
              }
              @case ('images') {
                @if (!datum.value || datum.value == '') {
                  <span>No Files Selected</span>
                }
                @if (datum.value?.length > 0) {
                  <span>{{datum.value}}</span>
                }
              }
              @case ('files') {
                @if (datum.value == '') {
                  <span>No Files Selected</span>
                }
                @if (datum.value.length > 0) {
                  <span>{{datum.value}}</span>
                }
              }
              @default {
                <span>{{datum.value}}</span>
              }
            }
          </div>
        }
      </div>
    </div>
  </div>
}

<div class="mt-1 mb-1 me-1">
  <div class="input-group input-group-sm mt-1">
    <span class="input-group-text">Asset Types</span>
    <div class="flex-grow-1">
      <ng-select class="w-100" [items]="assetTypes" bindLabel="name" [(ngModel)]="selectedAssetType"
        (change)="selectAssetType($event)" [searchable]="true" placeholder="Search Asset Types">
      </ng-select>
    </div>
  </div>
</div>

<div class="d-flex flex-column gap-2" style="max-height:500px">
  <div style="max-height:400px;">
    <div class="d-flex border-start flex-grow-1 w-100" style="overflow-x: auto; overflow-y: auto">
      <div class="d-flex justify-content-center align-items-center flex-grow-1">
        @if (!(selectedAssetType$ | async)) {
          <span class="fs-3 p-2">No Asset Type Selected</span>
        }
        @if (selectedAssetType$ | async) {
          <div class='h-100 w-100' [ngClass]="{'bg-light bg-gradient': true}"
            (scroll)="onTableScroll($event)">
            <table class="table table-striped table-hover w-100">
              <thead>
                <tr>
                  <th style="height:50px">
                    <div class="text-nowrap">
                      <span>Asset ID</span>
                      <i [ngClass]="{'ms-1 fa': true, 'fa-caret-down': sortOrder == 'ASC' && !sortByFieldID, 'fa-caret-up': (sortOrder == 'DESC' && !sortByFieldID) || sortByFieldID}"
                        style="cursor: pointer;">
                      </i>
                    </div>
                  </th>
                  @for (field of assetFields; track field; let i = $index) {
                    <th style="height:50px">
                      @switch (field.type) {
                        @case ('images') {
                          <div class="d-flex align-items-center">
                            <span>{{field.name}}</span>
                          </div>
                        }
                        @case ('files') {
                          <div class="d-flex align-items-center">
                            <span>{{field.name}}</span>
                          </div>
                        }
                        @default {
                          <div
                            class="d-flex align-items-center input-group input-group-sm flex-nowrap">
                            <div class="input-group-text">
                              <span>{{field.name}}</span>
                                                    <i [ngClass]="{
                                            'ms-1 fa': true, 
                                            'fa-caret-down': sortByFieldID == field.id && sortOrder == 'ASC', 
                                            'fa-caret-up': sortByFieldID != field.id || (sortByFieldID == field.id && sortOrder == 'DESC')
                                        }" (click)="sortByField(field)" style="cursor: pointer;">
                              </i>
                            </div>
                            <input type="search" class='form-control flex-grow-1'
                              style="flex-shrink:0; min-width: 100px;"
                              [value]="filterMap.get(field.id) ? filterMap.get(field.id) : ''"
                              (focusout)="filter(field, $event.target.value)"
                              placeholder="Filter">
                            </div>
                          }
                        }
                      </th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (row of assetTableRows; track row) {
                    <tr [style.cursor]='"pointer"'
                      [ngClass]="{'table-primary': selectedAsset?.id == row.assetID}"
                      (click)="selectAsset(row.assetID)">
                      <td>
                        <div class="d-flex gap-1 align-items-center">
                          <span>{{row.assetID}}</span>
                        </div>
                      </td>
                      @for (value of row.values; track value; let i = $index) {
                        <td>
                          <div class="d-flex align-items-center gap-1">
                            @switch (getValueType(i)) {
                              @case ('trueFalse') {
                                <span>{{value == 0 ? 'True' : 'False'}}</span>
                              }
                              @case ('location') {
                                <span class="text-truncate">
                                  {{value[1]}}, {{value[0]}}
                                </span>
                              }
                              @case ('chooseMultiple') {
                                <div class="d-flex flex-column">
                                  <span class="text-truncate">
                                    {{ isArray(value) ? value.join(', ') : value }}
                                  </span>
                                </div>
                              }
                              @case ('images') {
                                @if (!value || value == '') {
                                  <span>No Files Selected</span>
                                }
                                @if (value?.length > 0) {
                                  <span>{{value}}</span>
                                }
                              }
                              @case ('files') {
                                @if (value == '') {
                                  <span>No Files Selected</span>
                                }
                                @if (value.length > 0) {
                                  <span>{{value}}</span>
                                }
                              }
                              @default {
                                <span>{{value}}</span>
                              }
                            }
                          </div>
                        </td>
                      }
                    </tr>
                  }
                  @if (assetTableRows.length == 0 && loading) {
                    <div class="p-3 fs-5 text-muted">
                      Loading...
                    </div>
                  }
                  @if (assetTableRows.length == 0 && !loading) {
                    <div class="p-3 fs-5 text-muted">
                      No Entries
                    </div>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      </div>
    </div>
  </div>